import { usePendingWorkingPatternRequestQuery, WorkingPatternPeriods } from '../gql/graphql.generated';

export const useMyPendingWorkPattern = () => {
  const [{ data: myPendingWorkingPatternData }] = usePendingWorkingPatternRequestQuery();
  const pendingRequest = myPendingWorkingPatternData?.myPendingWorkingPatternRequest;
  return pendingRequest as WorkingPatternPeriods;
};
